/**
 * @engine/input — Scale Processor
 *
 * Scales values by a factor.
 */

import type { ProcessorType, ControlValue, ScaleParams } from '../types';
import { InputProcessor, registerProcessor } from './InputProcessor';

/**
 * Scale processor — multiplies values by a factor
 */
export class ScaleProcessor extends InputProcessor {
  readonly type: ProcessorType = 'scale';

  private readonly factor: number;

  constructor(params: Partial<ScaleParams> = {}) {
    super(params as Record<string, unknown>);
    this.factor = params.factor ?? 1;
  }

  process(value: ControlValue): ControlValue {
    if (typeof value === 'number') {
      return value * this.factor;
    }

    if (this.isVec2(value)) {
      return {
        x: value.x * this.factor,
        y: value.y * this.factor,
      };
    }

    if (this.isVec3(value)) {
      return {
        x: value.x * this.factor,
        y: value.y * this.factor,
        z: value.z * this.factor,
      };
    }

    return value;
  }
}

registerProcessor('scale', ScaleProcessor);
